import React, { Component } from "react";
import Popup from "reactjs-popup";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InputRange from "react-input-range";
import RangeMarker from "./RangeMarker";
import "react-input-range/lib/css/index.css";
import InputRadioButton from "./InputRadioButton";

library.add(faInfoCircle);

// This add Unit to the end of input field
function AddUnit(e) {
  if (e.unit && e.type !== "range") {
    if (!e.staticForm) {
      return (
        <div className="input-group-append">
          <span className="input-group-text">{e.unit}</span>
        </div>
      );
    } else {
      return " " + e.unit;
    }
  }
  return null;
}

function AddCurrency(e) {
  if (e.currency) {
    if (!e.staticForm) {
      return (
        <div className="input-group-prepend">
          <span className="input-group-text">{e.currency}</span>
        </div>
      );
    } else {
      return e.currency;
    }
  }
  return null;
}

// This will bold the text
function BoldText(e) {
  let myTitle = e.title;
  if (!e.bold) {
    // Add this to allow bold inside the title
    // it’s easy to inadvertently expose your users to a cross-site scripting (XSS) attack
    // so make sure this is not on the input field
    let myContent = { __html: myTitle }
    return <span dangerouslySetInnerHTML={myContent}></span>;
  }
  return <strong>{myTitle}</strong>;
}

function Checkbox(e) {
  let checked = e.show ? true : false;
  if (e.checkbox) {
    return (
      <React.Fragment>
        <div className="container form-group pb-5">
          <div className="row">
            <div className="col-lg-12 text-center">
              <label>
                <BoldText title={e.checkboxLabel} />
              </label>
              <div className="col-lg-12">
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={e.onCheckboxChange}
                />
              &nbsp;Yes
            </div>
            </div>
          </div>
          <div className="row">

          </div>
        </div>
      </React.Fragment>
    );
  } else {
    return null;
  }
}

function FieldType(e) {
  let label = e.rangeLabel ? e.rangeLabel : "";

  if (!e.staticForm) {
    // input field
    if (e.type === "range") {
      let max_value = 100;
      let min_value = 0;
      let range_step = 1;
      // Preset Default Value
      if (e.maxValue !== null) {
        max_value = e.maxValue;
      }
      if (e.minValue !== null) {
        min_value = e.minValue;
      }
      if (e.step !== null) {
        range_step = e.step;
      }

      return (
        <React.Fragment>
          <div className="range-container">
            <InputRange
              maxValue={max_value}
              minValue={min_value}
              formatLabel={(value) => `${value} ` + label}
              name={e.name}
              value={e.value}
              step={range_step}
              onChange={e.onSlideChange}
            />
            <RangeMarker step={range_step} minValue={min_value} maxValue={max_value} />
          </div>
        </React.Fragment>
      );
    } else {
      // Default - input field
      return (
        <input
          className="form-control"
          type="number"
          min="0"
          name={e.name}
          value={e.value}
          onChange={e.onChange}
        />
      );
    }
  } else {
    return (
      <React.Fragment>
        <input
          className="form-control"
          type="hidden"
          min="0"
          name={e.name}
          value={e.value}
          onChange={e.onChange}
          readOnly
        />
        {e.value}
      </React.Fragment>
    );
  }
}

function PopupContent(e) {
  if (e.popUp) {
    // if is Mobile version we want to use click
    if (e.isMobile) {
      return (
        <Popup
          trigger={
            <span className="popup-button">
              {" "}
              <FontAwesomeIcon icon={faInfoCircle} />
            </span>
          }
          className="m-ver"
          modal
          closeOnDocumentClick
        >
          {(close) => (
            <React.Fragment>
              <div className="modal">
                <div className="close" onClick={close}>
                  &times;
                </div>
                <div className="content">{e.popUp}</div>
              </div>
            </React.Fragment>
          )}
        </Popup>
      );
    } else {
      // if Desktop we want to use hover
      return (
        <Popup
          trigger={
            <span className="popup-button">
              {" "}
              <FontAwesomeIcon icon={faInfoCircle} />
            </span>
          }
          className="d-ver"
          on="hover"
          position="top center"
          keepTooltipInside
        >
          <React.Fragment>
            <div className="modal">
              <div className="content">{e.popUp}</div>
            </div>
          </React.Fragment>
        </Popup>
      );
    }
  } else {
    return null;
  }
}

class QuestionSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      [`${this.props.id}`]: this.props.show,
      displayTextFields: true,
    };

    this.onFieldChange = this.onFieldChange.bind(this);
    this.onSlideChange = this.onSlideChange.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.radioButtonChangeHandler = this.radioButtonChangeHandler.bind(this);
  }

  onFieldChange(e) {
    let fieldName = e.target.name;
    let fieldValue = e.target.value;
    let type = "input";

    this.props.onChange(fieldName, fieldValue, type);
  }

  onSlideChange(fieldValue) {
    this.props.onChange(this.props.propName, fieldValue);
  }

  onCheckboxChange(e) {
    let checkboxArray = this.props.checkboxArray;
    let fieldName = this.props.propName;
    let fieldValue = e.target.checked;
    let fieldID = this.props.id;
    let type = "checkbox";

    let newArray = { ...checkboxArray, [fieldID]: fieldValue };
    this.props.onChange(fieldName, fieldValue, type, newArray);
  }

  /*
   * ============================= Radio Button ===============================
   * Note
   * - This info apply to: radioButtonChangeHandler & setStep5ShowHideInputField
   * - These methods are only targeting step 5
   * - The radio button here is used for only one task and it is not dynamic.
   * - This is a workaround to show or hide input text fields on Step 5
   *   using the radio button as the trigger.
   * - If the app needs more radio buttons, this functionality will need
   *   to change.
   */
  radioButtonChangeHandler(event) {
    this.setState({ displayTextFields: event.target.value === "Yes" });
    // Workaround
    // Same functionality as OnCheckboxChange()


    let checkboxArray = this.props.checkboxArray;
    let fieldName = this.props.propName;
    let fieldValue = event.target.value === "Yes";
    let fieldID = this.props.id;
    let type = "checkbox";

    let newArray = { ...checkboxArray, [fieldID]: fieldValue };
    this.props.onChange(fieldName, fieldValue, type, newArray);
  }
  setStep5ShowHideInputField() {
    if (this.props.stepNumber === 5 && this.state.displayTextFields === false) {
      return false;
    }
    return true;
  }


  render() {
    let id = this.props.id;
    let title = this.props.title;
    let name = this.props.propName;
    let value = this.props.propValue;
    let bold = this.props.bold;
    let unit = this.props.unit;
    let rangeLabel = this.props.unit;
    let currency = this.props.currency;
    let staticForm = this.props.staticForm;
    let popUp = this.props.popUp;
    let type = this.props.type;
    let maxValue = this.props.maxValue;
    let minValue = this.props.minValue;
    let checkbox = this.props.checkbox;
    let checkboxLabel = this.props.checkboxLabel;
    let checkboxArray = this.props.checkboxArray;
    let displayTextFields = this.setStep5ShowHideInputField();
    let isMobile = this.props.isMobile;


    let step = this.props.step;

    let colWidth;
    if (type === "range") {
      colWidth = "col-10 col-sm-8 col-sm-8 col-lg-11";
    } else {
      colWidth = "col-sm-12 col-md-6 col-lg-4 ";
    }

    return (
      <div className="container-fluid pb-4 form-group">
        <InputRadioButton
          id={id}
          active={this.props.radioButton}
          question={this.props.radioButtonQuestion}
          options={this.props.radioButtonOptions}
          show={this.props.show}
          changed={this.radioButtonChangeHandler}
          checkboxArray={checkboxArray}
        />
        <Checkbox
          id={id}
          checkbox={checkbox} handleInputChange
          checkboxLabel={checkboxLabel}
          show={this.props.show}
          checkboxArray={checkboxArray}
          onCheckboxChange={this.onCheckboxChange}
        />
        <div className={displayTextFields ? 'show' : 'hide'}>
          <div className="row">
            <div className="col-lg-12 text-center">
              <label>
                <BoldText title={title} bold={bold} />
                <PopupContent popUp={popUp} isMobile={isMobile} />
              </label>

            </div>
          </div>

          <div className="row justify-content-center">
            <div className={colWidth}>
              <div className="input-group py-4">
                <AddCurrency currency={currency} staticForm={staticForm} />
                <FieldType
                  name={name}
                  value={value}
                  staticForm={staticForm}
                  type={type}
                  maxValue={maxValue}
                  minValue={minValue}
                  rangeLabel={rangeLabel}
                  onChange={this.onFieldChange}
                  onSlideChange={this.onSlideChange}
                  checkbox={checkbox}
                  step={step}
                />
                <AddUnit type={type} unit={unit} staticForm={staticForm} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default QuestionSection;
